// the number of milliseconds of a debounce timing window
export const DEBOUNCE_TIME = 200;
